const W = 1224;
const H = 700;

const COLOR_BLACK = '#000000';
const COLOR_WHITE = '#ffffff';

const FONT_FAMILY = '"Helvetica Neue", Arial, sans-serif';
const FONT_TITLE = `400 16px ${FONT_FAMILY}`;

const LOGO_TARGET_W = 520;
const WATERMARK_ALPHA = 0.06;

/** @type {Map<string, Promise<CanvasImageSource>>} */
const templateCache = new Map();

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error(`Failed to load image: ${src}`));
    img.src = src;
  });
}

async function buildBaseTemplate(t) {
  const [logoImg, watermarkImg] = await Promise.all([
    loadImage('/warecloud-title.png').catch(() => null),
    loadImage('/Warecloud-icon.png').catch(() => null),
  ]);

  const OffscreenCanvasRef =
    typeof window !== 'undefined'
      ? window.OffscreenCanvas
      : typeof global !== 'undefined'
      ? global.OffscreenCanvas
      : null;
  const canUseOffscreenCanvas = !!OffscreenCanvasRef;
  const workingCanvas = canUseOffscreenCanvas
    ? new OffscreenCanvasRef(W, H)
    : Object.assign(document.createElement('canvas'), { width: W, height: H });
  const ctx = workingCanvas.getContext('2d');

  if (!ctx) {
    throw new Error('Failed to initialize receipt template canvas context');
  }

  ctx.globalCompositeOperation = 'source-over';
  ctx.globalAlpha = 1;

  ctx.fillStyle = COLOR_WHITE;
  ctx.fillRect(0, 0, W, H);

  if (watermarkImg) {
    ctx.save();
    ctx.globalAlpha = WATERMARK_ALPHA;
    const wmH = H * 0.5;
    const wmW = (watermarkImg.width / watermarkImg.height) * wmH;
    ctx.drawImage(watermarkImg, 0, (H - wmH) / 2, wmW, wmH);
    ctx.restore();
  }

  ctx.font = FONT_TITLE;
  ctx.fillStyle = COLOR_BLACK;
  ctx.textAlign = 'center';
  ctx.fillText(t('delivery_receipt_title', { ns: 'glossary' }), W / 2, 30);

  let logoH = 0;
  if (logoImg) {
    logoH = (logoImg.height / logoImg.width) * LOGO_TARGET_W;
    const logoX = (W - LOGO_TARGET_W) / 2;
    ctx.drawImage(logoImg, logoX, 50, LOGO_TARGET_W, logoH);
  }

  if (typeof createImageBitmap === 'function') {
    const bitmap = await createImageBitmap(workingCanvas);
    workingCanvas.width = 0;
    return bitmap;
  }

  return workingCanvas;
}

export function getDeliveryReceiptTemplate(t, localeKey) {
  if (templateCache.has(localeKey)) {
    return templateCache.get(localeKey);
  }

  const promise = buildBaseTemplate(t).catch((err) => {
    templateCache.delete(localeKey);
    throw err;
  });

  templateCache.set(localeKey, promise);
  return promise;
}

export function clearDeliveryReceiptTemplate() {
  templateCache.forEach((promise) => {
    promise
      .then((resource) => {
        if (resource && typeof resource.close === 'function') {
          resource.close();
        }
      })
      .catch(() => {});
  });
  templateCache.clear();
}
